module.exports = __webpack_public_path__ + "static/media/signIn.75f72903.svg";